import React from 'react'

import {noop} from 'es-toolkit'

import './radio-group-field.scss'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

import RadioGroupItem from './RadioGroupItem'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    name?: string
    disabled?: boolean
    horizontal?: boolean
    value?: string
    onChange?: (
      value: string,
      name: string | undefined,
      event: React.ChangeEvent<HTMLInputElement>
    ) => void
  }
>

const RadioGroupField = ({
  className,
  children,
  value,
  name,
  disabled = false,
  horizontal = false,
  onChange = noop,
  ...props
}: Props) => {
  const actualName = useUniqueId(name)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value, actualName, event)
  }

  return (
    <div {...props} className={cn('RadioGroupField', {horizontal}, className)}>
      {mapChildrenWithFragments<React.ComponentProps<typeof RadioGroupItem>>(
        children,
        child =>
          child &&
          React.cloneElement(child, {
            onChange: handleChange,
            name: actualName,
            checked: value === child.props.value,
            disabled: child.props.disabled || disabled,
          })
      )}
    </div>
  )
}

export default RadioGroupField
